import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    description: 'verify email modal header',
    defaultMessage: 'Verify your email',
    id: 'Z7/gy+',
  },
  action: {
    description: 'verify email modal action button',
    defaultMessage: 'Got it!',
    id: 'bmt4yo',
  },
  pleaseCheckEmail: {
    description: 'verify email modal steps to verify email',
    defaultMessage:
      'At ShipStation, we take your security seriously. To continue, please verify your email address using the link we sent to your account email address.',
    id: '1PH/nK',
  },
  contactSupport: {
    description: 'verify email modal contact support message',
    defaultMessage: "Didn't receive the email? Check your spam folder, or <link>send it again</link>.",
    id: 'lJLk/8',
  },
  emailResentTitle: {
    description: 'resend email verification success notification title',
    defaultMessage: 'Verification Email resent successfully',
    id: '2t7y7A',
  },
  emailResentBody: {
    description: 'resend email verification success notification body',
    defaultMessage: 'Please check your email and follow the instructions to verify your account.',
    id: 'vHtTWp',
  },
  emailResentErrorTitle: {
    description: 'resend email verification error notification title',
    defaultMessage: 'Verification Email resend failed',
    id: '8rWRJJ',
  },
  emailResentErrorBody: {
    description: 'resend email verification error notification body',
    defaultMessage: 'Please try again or contact support.',
    id: 'Dwv3ce',
  },
});
